import { addDays } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

/**
 *
 * @param productOrAppTrialLength
 * @returns current date in utc + trial length
 */
export const getNextBillDateForNewEntitlements = (productOrAppTrialLength?: string) => {
  if (!productOrAppTrialLength) {
    return '';
  }
  const date = new Date();
  const currentDateInUTC = utcToZonedTime(date, 'UTC');
  return addDays(currentDateInUTC, Number(productOrAppTrialLength)).getTime().toString();
};
